import { GetMembershipStatus } from '../contracts';
import axios, { AxiosError } from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import StatusCode from 'status-code-enum';

export const GetMembershipStatusApi =
  (endpoint: string): GetMembershipStatus =>
  async ({ sessionId }) => {
    try {
      const url = `${endpoint}/${sessionId}`;

      const response = await axios.get(url, createAxiosConfig(endpoint));

      LogCannon.blast('GetMembershipStatusApi success');
      return Promise.resolve(response.data);
    } catch (e: any | AxiosError) {
      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('GetMembershipStatusApi error', errorResponse);
      return Promise.reject({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'GetMembershipStatusApi failed',
          ...errorResponse,
        },
      });
    }
  };
